import { Card } from '@talos/kyoko';

export function DDHHedgeOrderStatusMissingCard() {
  return <Card>Unable to display DDH details as Hedge Order Status is unavailable.</Card>;
}
